module.exports = __webpack_public_path__ + "img/views.f3af1d4a.svg";